module.exports = __webpack_public_path__ + "img/vertical_6_2_7016.15b94d55.png";